/*
  Mikai LP の小さな動作(PageFly ランタイムの代わり)。MIK-1089

  PageFly から書き出した LP(layout/mikai-lp.liquid)で使う。jQuery に依存しない。
  1. data-href を持つ要素をリンクとして動かす(Enter / Space でも動く)
  2. ページ内リンク(#〜)は、上に 60px の余白を残してなめらかにスクロールする
  3. アコーディオン(.__pf details)の開閉。本文の高さアニメは .open で切り替わる
  4. スライドショー(.pf-slider)の前後ボタンとページ送りの点
  5. スマホの追従 CTA(#mobile-sticky)を、500px 以上スクロールしたら表示する
*/
(function () {
  'use strict';

  var SCROLL_GAP = 60;
  var STICKY_AFTER = 500;
  var FADE_MS = 400;
  var ACCORDION_MS = 300;

  function scrollToId(id) {
    var el = id && document.getElementById(id);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_GAP;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  function follow(el) {
    var href = el.getAttribute('data-href');
    if (!href) return;
    if (href.charAt(0) === '#' && scrollToId(href.slice(1))) return;
    if (el.getAttribute('data-target') === '_blank') {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.href = href;
    }
  }

  // 1, 2. リンク
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href^="#"]');
    if (anchor) {
      if (scrollToId(anchor.getAttribute('href').slice(1))) e.preventDefault();
      return;
    }
    if (e.target.closest('a, button, summary')) return;
    var block = e.target.closest('[data-href]');
    if (!block) return;
    e.preventDefault();
    follow(block);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var block = e.target;
    if (!block.hasAttribute || !block.hasAttribute('data-href')) return;
    e.preventDefault();
    follow(block);
  });

  // 3. アコーディオン
  // 開閉の判定は「押した結果どうなるはずか」で持つ。.open の付け外しは描画のあとなので、
  // 連打したときに .open で判定すると開く操作が二重に走る。
  var isOpen = new WeakMap();

  function setActive(details, on) {
    var header = details.querySelector(':scope > summary > [data-active]');
    if (header) header.setAttribute('data-active', on ? 'true' : 'false');
  }

  function closeDetails(details) {
    isOpen.set(details, false);
    details.classList.remove('open');
    setActive(details, false);
    setTimeout(function () {
      if (!isOpen.get(details)) details.open = false;
    }, ACCORDION_MS);
  }

  function openDetails(details) {
    var group = details.closest('[data-open-multiple]');
    if (group && group.getAttribute('data-open-multiple') === 'false') {
      group.querySelectorAll('details').forEach(function (other) {
        if (other !== details && isOpen.get(other) && other.closest('[data-open-multiple]') === group) closeDetails(other);
      });
    }
    isOpen.set(details, true);
    details.open = true;
    setActive(details, true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (isOpen.get(details)) details.classList.add('open');
      });
    });
  }

  document.querySelectorAll('.__pf details').forEach(function (details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;
    isOpen.set(details, details.open);
    if (details.open) details.classList.add('open');
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen.get(details)) closeDetails(details);
      else openDetails(details);
    });
  });

  // 4. スライドショー
  document.querySelectorAll('.pf-slider').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll(':scope > .pf-slide'));
    if (!slides.length) return;
    var prev = slider.querySelector(':scope > .pf-slider-prev');
    var next = slider.querySelector(':scope > .pf-slider-next');
    var nav = slider.querySelector(':scope > .pf-slider-nav');
    var dots = [];
    var current = -1;

    function indexNow() {
      var width = slides[0].getBoundingClientRect().width || slider.clientWidth;
      return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / width)));
    }

    function goTo(i) {
      var target = slides[Math.max(0, Math.min(slides.length - 1, i))];
      slider.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }

    function update() {
      var i = indexNow();
      if (i === current) return;
      current = i;
      slides.forEach(function (slide, k) {
        slide.classList.toggle('is-current', k === i);
        slide.classList.toggle('is-visible', k === i);
        slide.setAttribute('tabindex', '-1');
        if (k === i) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (dot, k) {
        dot.classList.toggle('active', k === i);
      });
      if (prev) prev.style.visibility = i === 0 ? 'hidden' : '';
      if (next) next.style.visibility = i === slides.length - 1 ? 'hidden' : '';
    }

    if (nav && !nav.children.length) {
      slides.forEach(function (slide, k) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to slide ' + (k + 1));
        dot.addEventListener('click', function () { goTo(k); });
        nav.appendChild(dot);
        dots.push(dot);
      });
    }
    if (prev) prev.addEventListener('click', function () { goTo(indexNow() - 1); });
    if (next) next.addEventListener('click', function () { goTo(indexNow() + 1); });

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }, { passive: true });

    slides.forEach(function (slide) { slide.style.scrollSnapStop = 'always'; });
    slider.classList.add('has-loaded');
    update();
  });

  // 5. 追従 CTA(スマホだけ。PC / タブレットは CSS の pf-*-hide で常に隠れる)
  var sticky = document.getElementById('mobile-sticky');
  if (sticky) {
    var shown = false;
    var timer = null;
    sticky.style.transition = 'opacity ' + FADE_MS + 'ms';

    var toggleSticky = function () {
      var want = window.pageYOffset > STICKY_AFTER;
      if (want === shown) return;
      shown = want;
      clearTimeout(timer);
      if (want) {
        sticky.style.opacity = '0';
        sticky.style.display = 'block';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { sticky.style.opacity = '1'; });
        });
      } else {
        sticky.style.opacity = '0';
        timer = setTimeout(function () { sticky.style.display = 'none'; }, FADE_MS);
      }
    };

    window.addEventListener('scroll', toggleSticky, { passive: true });
    toggleSticky();
  }
})();
